import { Skeleton } from 'antd';
import React from 'react';

const IndividualVideoSkeleton = () => {
  return (
    <div className="mb-[25px] px-2 pt-2 rounded-[10px] flex items-start justify-between flex-wrap border">
      <div className="relative bg-white dark:bg-white10 rounded-[10px] px-[10px] pt-[10px] pb-[10px]">
        <h2 className="mb-3 text-dark dark:text-white87 text-lg sm:text-2xl font-semibold">
          <Skeleton.Input size="small" active block />
        </h2>
        <p className="mb-4 font-normal text-body dark:text-white60 text-15">
          <Skeleton.Input size="small" active block />
        </p>
        <Skeleton.Button active size={'default'} />
      </div>
      <Skeleton
        active
        paragraph={{
          rows: 4, // Number of lines in the skeleton paragraph
          width: ['100%', '100%', '80%', '50%'], // Width of each line, can be percentage or fixed value
        }}
      />
      <div className="relative bg-white dark:bg-white10 border rounded-[10px] px-[10px] pt-[10px] pb-[10px] mb-2">
        <Skeleton.Image active block />
      </div>
    </div>
  );
};

export default IndividualVideoSkeleton;
